import React, {useRef} from 'react';
import classNames from 'classnames';
import Picker, {SKIN_TONE_NEUTRAL} from 'emoji-picker-react';

import useOnClickOutside from '../../hooks/useOnClickOutside';

type Props = {
  className?: string,
  onClose: () => void;
  onEmojiClick: (event:any, emojiObject:any) => void;
};

function EmojiPickerPanel({ className, onClose, onEmojiClick }: Props) {

  const ref = useRef(null);
	useOnClickOutside(ref, (): any => {
		onClose();
  });
  
  const emojiClick = (event:any, emojiObject:any) => {		
    onEmojiClick(event, emojiObject);
  }

  return (
    <div className={classNames('emoji-picker-wrapper', className)} ref={ref}>
      <Picker 
        onEmojiClick={emojiClick} 
        disableSkinTonePicker={true}
        preload={true}
        skinTone={SKIN_TONE_NEUTRAL}
      />
    </div>
  );
}

EmojiPickerPanel.defaultProps = {
};

export default EmojiPickerPanel;